import {
  INSERT_PLUGIN_BUTTONS,
  FORMATTING_BUTTONS as RCE_FORMATTING_BUTTONS,
} from 'wix-rich-content-editor-common';

export const PLUGIN_BUTTONS = [
  INSERT_PLUGIN_BUTTONS.IMAGE,
  INSERT_PLUGIN_BUTTONS.VIDEO,
  INSERT_PLUGIN_BUTTONS.GIF,
  INSERT_PLUGIN_BUTTONS.FILE,
];

export const FORMATTING_BUTTONS = [
  RCE_FORMATTING_BUTTONS.BOLD,
  RCE_FORMATTING_BUTTONS.ITALIC,
  RCE_FORMATTING_BUTTONS.UNDERLINE,
  RCE_FORMATTING_BUTTONS.TITLE,
  RCE_FORMATTING_BUTTONS.BLOCKQUOTE,
  RCE_FORMATTING_BUTTONS.ALIGN_LEFT,
  RCE_FORMATTING_BUTTONS.ALIGN_CENTER,
  RCE_FORMATTING_BUTTONS.ALIGN_RIGHT,
  RCE_FORMATTING_BUTTONS.ALIGN_JUSTIFY,
  RCE_FORMATTING_BUTTONS.ORDERED_LIST,
  RCE_FORMATTING_BUTTONS.UNORDERED_LIST,
  RCE_FORMATTING_BUTTONS.LINK,
  RCE_FORMATTING_BUTTONS.SPOILER,
  RCE_FORMATTING_BUTTONS.CODE_BLOCK,
];
